<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>WADA Klassificeringer</PageTitle>
    <p v-if="getAllWADA.length === 0">
      Der er ingen oprettede WADA klassificeringer.
    </p>

    <div class="row">
      <div
        class="col-xs-12"
        v-if="getAllWADA.length"
      >
        <div class="row bottom-xs base-table__header">
          <p class="col-xs-3 col-md-2">
            Status
          </p>
          <p class="col-xs-5 col-md-8">
            Navn
          </p>
        </div>
        <Box
          v-for="(wada, wadaIndex) in getAllWADA"
          :key="wadaIndex"
          :open="wada.editMode"
        >
          <div class="row">
            <div class="col-xs-3 col-md-2">
              {{ wada.deleted | IsDeleted }}
            </div>
            <div class="col-xs-5 col-md-8">
              <p>{{ wada.name }}</p>
              <a
                :href="wada.link"
                class="wada-link highlight"
                target="_blank"
                v-if="wada.link"
              >{{ wada.link }}</a>
            </div>
            <div class="col-xs-2 end-xs">
              <font-awesome-icon
                class="base-table__icon-edit"
                icon="pencil-alt"
                @click="toggleEditMode(wada)"
              />
            </div>
          </div>
          <div
            class="row"
            v-if="wada.editMode"
          >
            <div class="col-xs-12">
              <UpdateWADAClassification :form="wada" />
            </div>
          </div>
        </box>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <CreateWADAClassification @created="wadaCreated" />
      </div>
    </div>
  </Page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Page from './Page.vue';
import UpdateWADAClassification from '../components/Forms/WADAClassification/UpdateWADAClassification.vue';
import CreateWADAClassification from '../components/Forms/WADAClassification/CreateWADAClassification.vue';
import Box from '../components/Box.vue';
import Pageload from '../mixins/Pageload';
import Request from '../mixins/Request';
import IsDeleted from '../filters/IsDeleted';

export default {
    name: 'WADAClassification',
    mixins: [Pageload, Request],
    components: {
        Box, CreateWADAClassification, UpdateWADAClassification, Page,
    },
    filters: { IsDeleted },
    computed: {
        ...mapGetters('wada', [
            'getAllWADA',
        ]),
    },
    methods: {
        ...mapActions('wada', [
            'loadWADA',
        ]),
        toggleEditMode(wada) {
            this.$set(wada, 'editMode', !wada.editMode);
        },
        async wadaCreated() {
            await this.initLoad();
        },
        async initLoad() {
            try {
                await this.loadWADA();
                this.pageloaded();
            } catch (error) {
                //
            }
        },
    },
    async created() {
        await this.initLoad();
    },
};
</script>

<style lang="scss" scoped>
.wada-link {
    margin-top: 10px;
    display: inline-block;
}
</style>
